/* Common Imports */
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import React from "react";

/* Component Imports */

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },

    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  mainContainer: {
    // padding: "0rem 8rem 0rem 8rem",
    padding: "0rem 8rem 2rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
    width: "100%",
    margin: "2rem 0rem 0rem 0rem",
  },
  heading: {
    width: "100%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 2.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
      margin: "0rem 0rem 1.5rem 0rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  subHeading: {
    margin: "0rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "1.5rem",
    },
  },
  column: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    gap: "1rem",
    margin: "2.5rem 0rem 2.5rem 0rem",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "1rem",
      margin: "1rem 0rem 1rem 0rem",
    },
  },
  iconTextCard: {
    width: "100%",
    padding: "1.5rem 1.5rem 1.5rem 1.5rem",
    boxShadow: "0px 4px 18px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "1rem",
    border: "1px solid  rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  root: {
    width: "100%",
    border: "1px solid var(--Other-New-Divider, rgba(0, 0, 0, 0.12))",
    borderRadius: "1rem",
    padding: "2rem 2rem 4rem 2rem",
    height: "733px",
    overflow: "hidden",
    [theme.breakpoints.down("lg")]: {
      height: "850px",
      margin: "0rem 0rem 1rem 0rem",
    },
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      padding: "1rem 1rem 1rem 1rem",
    },
  },
  customAccordion: {
    boxShadow: "none",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    "&:before": {
      display: "none",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 0rem 1rem 0rem",
      //   margin: "0rem 0rem 1rem 0rem",
    },
  },
  unitButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "0.5rem",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      gap: "0.25rem",
    },
  },
  timeButton: {
    padding: "0.5rem 1rem",
    fontSize: "0.813rem",
    fontWeight: "500",
    color: "#693471",
    background: "#FFFFFF",
    border: "1px solid #693471",
    borderRadius: "0.5rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  activeTimeButton: {
    background: "#693471",
    color: "#FFFFFF",
  },
  imgsize: {
    width: "100%",
    height: "500px",
    objectFit: "contain",

    [theme.breakpoints.down("sm")]: {
      width: "800px",
    },
    [theme.breakpoints.up("xl")]: {
      width: "800px",
      height: "600px",
    },
    // [theme.breakpoints.down("md")]: {
    //   height: "auto",
    //   objectFit: "contain",
    // },
    [theme.breakpoints.down("xs")]: {
      width: "250px",
      height: "auto",
    },
  },
  cardsubText: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.688rem",
    color: "#666666",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
      lineHeight: "1.688rem",
    },
  },
  innercontainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    gap: "2rem",
  },
  floorunit: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0.5rem 0rem 0rem 0rem",
  },
  typecontent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "1.5rem",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "0.5rem",
    },
  },
  sba: {
    fontSize: "1.125rem",
    fontWeight: 400,
    lineHeight: "1.688rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
      lineHeight: "1.688rem",
    },
  },
  ca: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.688rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
      lineHeight: "1.688rem",
    },
  },
  contentcard: {
    width: "100%",
    padding: "1.5rem 1.5rem 1.5rem 1.5rem",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "1rem",
    margin: "1rem 0rem 0rem 0rem",
    background: "#FAFAFA",
    [theme.breakpoints.down("xs")]: {
      padding: "0.5rem 1rem 0.5rem 1rem",
      borderRadius: "1rem",
    },
  },
  unitspacing: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "#FAFAFA",
    padding: "1rem",
    borderRadius: "1rem",
    [theme.breakpoints.down("xs")]: {
      padding: "1rem",
      borderRadius: "1rem",
    },
  },
  accordionSummary: {
    [theme.breakpoints.down("xs")]: {
      padding: "0rem",
    },
  },
  accordiondetails: {
    [theme.breakpoints.down("xs")]: {
      padding: "0rem",
    },
  },
  navigationButton: {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    margin: "0 10px",
    zIndex: 1,
    width: "48px",
    height: "48px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    "& svg": {
      fontSize: "32px",
      color: "#693471",
    },
  },
  //   soldOutButton: {
  //     background: "#E0E0E0", // Gray background
  //     color: "#9E9E9E", // Gray text
  //     border: "1px solid #BDBDBD", // Gray border
  //     cursor: "not-allowed", // Disabled cursor
  //   },
  //   soldOutDetails: {
  //     opacity: 0.5,
  //     pointerEvents: "none",
  //   },
  //   soldOutText: {
  //     color: "#9E9E9E",
  //     fontWeight: 600,
  //     textAlign: "center",
  //     // marginTop: "1rem",
  //     fontSize: "0.75rem", // Updated font size
  //   },
  dialogContent: {
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    maxWidth: "90%",
    margin: "0 auto",
  },
  dialogImage: {
    maxWidth: "95%",
    maxHeight: "80vh",
    width: "auto",
    height: "auto",
    objectFit: "contain",
    marginBottom: theme.spacing(2),
  },
  dialogDetails: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "0.5rem",
  },
  dialogCard: {
    flex: 1,
    padding: theme.spacing(2),
    backgroundColor: "#FAFAFA",
    borderRadius: "1rem",
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  dialogUnitNumber: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#693471",
    padding: "0.5rem 0.5rem",
    textAlign: "left",
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  closeButton: {
    position: "absolute",
    right: "20px",
    top: "17px",
    color: "#212121",
    zIndex: 1,
  },
  clickableImage: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.9,
    },
  },
}));

const unitDetails = {
  G001: {
    superBuiltUpArea: "1383 SFT",
    carpetArea: "1046 SFT",
    image: "images/icons/heavie/units/G101.webp",
  },
  G002: {
    superBuiltUpArea: "1392 SFT",
    carpetArea: "1060 SFT",
    image: "images/icons/heavie/units/G102.webp",
  },
  G003: {
    superBuiltUpArea: "915 SFT",
    carpetArea: "663 SFT",
    image: "images/icons/heavie/units/G103.webp",
  },
  G004: {
    superBuiltUpArea: "1381 SFT",
    carpetArea: "1042 SFT",
    image: "images/icons/heavie/units/G104.webp",
  },
  G005: {
    superBuiltUpArea: "1301 SFT",
    carpetArea: "902 SFT",
    image: "images/icons/heavie/units/G105.webp",
  },
  G006: {
    superBuiltUpArea: "1311 SFT",
    carpetArea: "907 SFT",
    image: "images/icons/heavie/units/G106.webp",
  },
  G007: {
    superBuiltUpArea: "1208 SFT",
    carpetArea: "881 SFT",
    image: "images/icons/heavie/units/G107.webp",
  },
  F101: {
    superBuiltUpArea: "1524 SFT",
    carpetArea: "1044 SFT",
    image: "images/icons/heavie/units/type1.webp",
  },
  F102: {
    superBuiltUpArea: "1542 SFT",
    carpetArea: "1064 SFT",
    image: "images/icons/heavie/units/type2.webp",
  },
  F103: {
    superBuiltUpArea: "1653 SFT",
    carpetArea: "1078 SFT",
    image: "images/icons/heavie/units/type3.webp",
  },
  F104: {
    superBuiltUpArea: "1528 SFT",
    carpetArea: "1019 SFT",
    image: "images/icons/heavie/units/type4.webp",
  },
  F105: {
    superBuiltUpArea: "1255 SFT",
    carpetArea: "888 SFT",
    image: "images/icons/heavie/units/type5.webp",
  },
  F106: {
    superBuiltUpArea: "1279 SFT",
    carpetArea: "904 SFT",
    image: "images/icons/heavie/units/type6.webp",
  },
  F107: {
    superBuiltUpArea: "1413 SFT",
    carpetArea: "885 SFT",
    image: "images/icons/heavie/units/type7.webp",
  },
  F201: {
    superBuiltUpArea: "1524 SFT",
    carpetArea: "1044 SFT",
    image: "images/icons/heavie/units/type1.webp",
  },
  F202: {
    superBuiltUpArea: "1542 SFT",
    carpetArea: "1064 SFT",
    image: "images/icons/heavie/units/type2.webp",
  },
  F203: {
    superBuiltUpArea: "1653 SFT",
    carpetArea: "1078 SFT",
    image: "images/icons/heavie/units/type3.webp",
  },
  F204: {
    superBuiltUpArea: "1528 SFT",
    carpetArea: "1019 SFT",
    image: "images/icons/heavie/units/type4.webp",
  },
  F205: {
    superBuiltUpArea: "1255 SFT",
    carpetArea: "888 SFT",
    image: "images/icons/heavie/units/type5.webp",
  },
  F206: {
    superBuiltUpArea: "1279 SFT",
    carpetArea: "904 SFT",
    image: "images/icons/heavie/units/type6.webp",
  },
  F207: {
    superBuiltUpArea: "1413 SFT",
    carpetArea: "885 SFT",
    image: "images/icons/heavie/units/type7.webp",
  },
  F301: {
    superBuiltUpArea: "1524 SFT",
    carpetArea: "1044 SFT",
    image: "images/icons/heavie/units/type1.webp",
  },
  F302: {
    superBuiltUpArea: "1542 SFT",
    carpetArea: "1064 SFT",
    image: "images/icons/heavie/units/type2.webp",
  },
  F303: {
    superBuiltUpArea: "1653 SFT",
    carpetArea: "1078 SFT",
    image: "images/icons/heavie/units/type3.webp",
  },
  F304: {
    superBuiltUpArea: "1528 SFT",
    carpetArea: "1019 SFT",
    image: "images/icons/heavie/units/type4.webp",
  },
  F305: {
    superBuiltUpArea: "1255 SFT",
    carpetArea: "888 SFT",
    image: "images/icons/heavie/units/type5.webp",
  },
  F306: {
    superBuiltUpArea: "1279 SFT",
    carpetArea: "904 SFT",
    image: "images/icons/heavie/units/type6.webp",
  },
  F307: {
    superBuiltUpArea: "1413 SFT",
    carpetArea: "885 SFT",
    image: "images/icons/heavie/units/type7.webp",
  },
};

const AvailableUnitsSection = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [activeUnit, setActiveUnit] = React.useState("G001");
  const [expandedAccordion, setExpandedAccordion] = React.useState("Ground Floor");
  const [touchStart, setTouchStart] = React.useState(null);
  const [touchEnd, setTouchEnd] = React.useState(null);

  // Add the touch handler functions
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      handleNextImage();
    }
    if (isRightSwipe) {
      handlePreviousImage();
    }
  };

  const handleNextImage = () => {
    const units = Object.keys(unitDetails);
    const currentIndex = units.indexOf(activeUnit);
    const nextIndex = (currentIndex + 1) % units.length;
    const nextUnit = units[nextIndex];
    setActiveUnit(nextUnit);
    setSelectedImage(unitDetails[nextUnit].image);
  };

  const handlePreviousImage = () => {
    const units = Object.keys(unitDetails);
    const currentIndex = units.indexOf(activeUnit);
    const previousIndex = currentIndex === 0 ? units.length - 1 : currentIndex - 1;
    const previousUnit = units[previousIndex];
    setActiveUnit(previousUnit);
    setSelectedImage(unitDetails[previousUnit].image);
  };

  //   const soldOutUnits = ["G001", "G005", "G006", "G007", "F105", "F106", "F205", "F206", "F302", "F303", "F304"];

  //   const handleUnitClick = (unit) => {
  //     if (!soldOutUnits.includes(unit)) {
  //       setActiveUnit(unit);
  //     }
  //   };

  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState("");

  const handleImageClick = (image, unit) => {
    setSelectedImage(image);
    setActiveUnit(unit);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleUnitClick = (unit) => {
    setActiveUnit(unit);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);

    // Automatically select the first unit of the expanded accordion
    if (isExpanded) {
      const defaultUnits = {
        "Ground Floor": "G001",
        "First Floor": "F101",
        "Second Floor": "F201",
        "Third Floor": "F301",
      };
      setActiveUnit(defaultUnits[panel]);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleCloseDialog}
        classes={{ paper: classes.dialogPaper }}
        onClick={handleCloseDialog}
      >
        <IconButton
          className={classes.closeButton}
          onClick={handleCloseDialog}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <div
          className={classes.dialogContent}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <Typography
            variant="h4"
            className={classes.dialogUnitNumber}
          >
            {activeUnit}
          </Typography>
          <div
            style={{
              position: "relative",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handlePreviousImage();
              }}
              className={classes.navigationButton}
              style={{ position: "absolute", left: 0 }}
              aria-label="previous image"
            >
              <NavigateBeforeIcon />
            </IconButton>
            <img
              src={selectedImage}
              alt="Floor Plan"
              className={classes.dialogImage}
            />
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleNextImage();
              }}
              className={classes.navigationButton}
              style={{ position: "absolute", right: 0 }}
              aria-label="next image"
            >
              <NavigateNextIcon />
            </IconButton>
          </div>
          <div className={classes.dialogDetails}>
            <div className={classes.dialogCard}>
              <Typography
                variant="body1"
                className={classes.sba}
              >
                SBA
              </Typography>
              <Typography
                variant="body1"
                className={classes.cardsubText}
              >
                {unitDetails[activeUnit]?.superBuiltUpArea}
              </Typography>
            </div>
            <div className={classes.dialogCard}>
              <Typography
                variant="body1"
                className={classes.ca}
              >
                CARPET AREA
              </Typography>
              <Typography
                variant="body1"
                className={classes.cardsubText}
              >
                {unitDetails[activeUnit]?.carpetArea}
              </Typography>
            </div>
          </div>
        </div>
      </Dialog>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <Typography
            variant="h6"
            component="span"
            className={classes.heading}
          >
            Units Details
          </Typography>
          <div className={classes.innercontainer}>
            <div className={classes.root}>
              {["Ground Floor", "First Floor", "Second Floor", "Third Floor"].map((floor, index) => {
                const units =
                  index === 0
                    ? ["G001", "G002", "G003", "G004", "G005", "G006", "G007"]
                    : index === 1
                    ? ["F101", "F102", "F103", "F104", "F105", "F106", "F107"]
                    : index === 2
                    ? ["F201", "F202", "F203", "F204", "F205", "F206", "F207"]
                    : ["F301", "F302", "F303", "F304", "F305", "F306", "F307"];

                return (
                  <Accordion
                    key={floor}
                    className={classes.customAccordion}
                    expanded={expandedAccordion === floor}
                    onChange={handleAccordionChange(floor)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${index + 1}-content`}
                      id={`panel${index + 1}-header`}
                      className={classes.accordionSummary}
                    >
                      <Typography className={classes.subHeading}>{floor}</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordiondetails}>
                      <div className={classes.unitspacing}>
                        <div className={classes.unitButtons}>
                          {units.map((unit) => (
                            <div
                              key={unit}
                              style={{ textAlign: "center" }}
                            >
                              <button
                                className={`${classes.timeButton} ${
                                  activeUnit === unit ? classes.activeTimeButton : ""
                                }`}
                                onClick={() => handleUnitClick(unit)}
                                // disabled={soldOutUnits.includes(unit)}
                              >
                                {unit}
                              </button>
                              {/* {soldOutUnits.includes(unit) && (
                                <Typography className={classes.soldOutText}>Sold Out</Typography>
                              )} */}
                            </div>
                          ))}
                        </div>
                        {isSmallScreen && activeUnit && (
                          <div className={classes.floorunit}>
                            <img
                              src={unitDetails[activeUnit]?.image}
                              alt={`${activeUnit} Floor Plan`}
                              className={`${classes.imgsize} ${classes.clickableImage}`}
                              onClick={() => handleImageClick(unitDetails[activeUnit]?.image, activeUnit)}
                            />
                            <div className={classes.typecontent}>
                              <div className={classes.contentcard}>
                                <Typography
                                  variant="body1"
                                  className={classes.sba}
                                >
                                  SBA
                                </Typography>
                                <Typography
                                  variant="body1"
                                  className={classes.cardsubText}
                                >
                                  {unitDetails[activeUnit]?.superBuiltUpArea}
                                </Typography>
                              </div>
                              <div className={classes.contentcard}>
                                <Typography
                                  variant="body1"
                                  className={classes.ca}
                                >
                                  CARPET AREA
                                </Typography>
                                <Typography
                                  variant="body1"
                                  className={classes.cardsubText}
                                >
                                  {unitDetails[activeUnit]?.carpetArea}
                                </Typography>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </div>
            {!isSmallScreen && (
              <div className={classes.floorunit}>
                {activeUnit ? (
                  <div>
                    <img
                      src={unitDetails[activeUnit]?.image}
                      alt={`${activeUnit} Floor Plan`}
                      className={`${classes.imgsize} ${classes.clickableImage}`}
                      onClick={() => handleImageClick(unitDetails[activeUnit]?.image, activeUnit)}
                    />
                    <div className={classes.typecontent}>
                      <div className={classes.contentcard}>
                        <Typography
                          variant="body1"
                          className={classes.sba}
                        >
                          SUPER BUILT UP AREA
                        </Typography>
                        <Typography
                          variant="body1"
                          className={classes.cardsubText}
                        >
                          {unitDetails[activeUnit]?.superBuiltUpArea}
                        </Typography>
                      </div>
                      <div className={classes.contentcard}>
                        <Typography
                          variant="body1"
                          className={classes.ca}
                        >
                          CARPET AREA
                        </Typography>
                        <Typography
                          variant="body1"
                          className={classes.cardsubText}
                        >
                          {unitDetails[activeUnit]?.carpetArea}
                        </Typography>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Typography
                    variant="body1"
                    className={classes.cardsubText}
                  >
                    Select a unit to view its details.
                  </Typography>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AvailableUnitsSection;
